import { useInfiniteQuery } from '@tanstack/react-query';

import { customerInvoicesService } from '@/services/customer/invoices.service';
import type { CustomerInvoicesPage } from '@/types/customer-invoices';

export const customerInvoicesKeys = {
  all: ['billing', 'invoices'] as const,
  list: (limit: number) => [...customerInvoicesKeys.all, { limit }] as const,
};

export function useCustomerInvoices(limit = 20) {
  return useInfiniteQuery<CustomerInvoicesPage>({
    queryKey: customerInvoicesKeys.list(limit),
    queryFn: ({ pageParam }) =>
      customerInvoicesService.listInvoices({
        limit,
        cursor: typeof pageParam === 'string' ? pageParam : null,
      }),
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.meta.nextCursor ?? undefined,
    staleTime: 30_000,
  });
}

